import React from 'react';
import ApplicationsVersionsTableView from '../../views/applications/versions';
import UUID from 'uuid';
import CurrentApplicationLabel from './current-label';

class ApplicationPermissionsTableScreen extends React.Component {

  state = {
    name: ''
  };

  onSave = async (data, setData) => {
    const input = {
      ...data,
      uuid: data.uuid || UUID.v4()
    };
    await setData({
      ...input
    });
  };

  onDelete = async (data, remove) => {
    if (!data.uuid) {
      return remove(data.uuid);
    }
    await remove(data.uuid);
  };

  getVersions() {
    return [
      {
        version: '0.0.0-SNAPSHOT',
        timestamp: 1551817505316,
        md5: 'db58982b42ff21aa7cdd096cd0f8df06',
        status: 'Bronze'
      },
      {
        version: '1.0.1',
        timestamp: 1551827543236,
        md5: '7959ed623ccb6222c2e3405f70f175d7',
        status: 'Silver'
      },
      {
        version: '1.0.2',
        timestamp: 1551837576595,
        md5: 'a4d36659d13be9d14f7e8fca3b6714dc',
        status: 'Silver'
      },
      {
        version: '1.0.3',
        timestamp: 1551838580571,
        md5: 'e31adf9e1af7aaff10b627c7953d1d0b',
        status: 'Gold'
      },

    ]
  }

  render() {
    return (
      <ApplicationsVersionsTableView
        name={(
          <React.Fragment>
            <CurrentApplicationLabel />&nbsp;Versions
          </React.Fragment>
        )}
        versions={this.getVersions()}
        onSave={this.onSave}
        onDelete={this.onDelete}
      />
    )
  }
}

export default ApplicationPermissionsTableScreen;



// WEBPACK FOOTER //
// ./src/app/applications/versions.js